export const formatNextPost = (nextScheduledAt) => {
  if (!nextScheduledAt) return "";
  const date = new Date(Number(nextScheduledAt));
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

export const summarizeHeroMetrics = (items = []) => {
  const totals = items.reduce(
    (result, item) => {
      result.queuedCount += item.queuedCount || 0;
      result.publishedThisWeek += item.publishedThisWeek || 0;
      result.failedCount += item.failedCount || 0;
      const nextScheduledAt = Number(item.nextScheduledAt);
      if (!Number.isFinite(nextScheduledAt) || nextScheduledAt <= 0) {
        return result;
      }
      if (
        result.nextScheduledAt == null ||
        nextScheduledAt < result.nextScheduledAt
      ) {
        result.nextScheduledAt = nextScheduledAt;
      }
      return result;
    },
    {
      queuedCount: 0,
      publishedThisWeek: 0,
      failedCount: 0,
      nextScheduledAt: null,
    }
  );

  return {
    ...totals,
    nextPostLabel: formatNextPost(totals.nextScheduledAt),
  };
};
